var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5C4 6.72876 4 4.84315 5.17157 3.67157C6.34315 2.5 8.22876 2.5 12 2.5H13.5C17.2712 2.5 19.1569 2.5 20.3284 3.67157C21.5 4.84315 21.5 6.72876 21.5 10.5V14.5C21.5 18.2712 21.5 20.1569 20.3284 21.3284C19.1569 22.5 17.2712 22.5 13.5 22.5H12C8.22876 22.5 6.34315 22.5 5.17157 21.3284C4 20.1569 4 18.2712 4 14.5V10.5Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79993 12.4741C9.37332 11.7302 9.16733 11.1228 9.04313 10.507C8.85943 9.59641 9.27981 8.70686 9.97622 8.13926C10.2706 7.89937 10.608 7.98133 10.782 8.29358L11.1749 8.99851C11.4864 9.55725 11.6421 9.83663 11.6112 10.1328C11.5803 10.429 11.3703 10.6702 10.9503 11.1527L9.79993 12.4741ZM9.79993 12.4741C10.6634 13.9797 12.0185 15.3356 13.5259 16.2001M13.5259 16.2001C14.2698 16.6267 14.8772 16.8327 15.493 16.9569C16.4036 17.1406 17.2931 16.7202 17.8607 16.0238C18.1006 15.7294 18.0187 15.392 17.7064 15.218L17.0015 14.8251C16.4427 14.5136 16.1634 14.3579 15.8672 14.3888C15.571 14.4197 15.3298 14.6297 14.8473 15.0497L13.5259 16.2001Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact02);
export default __webpack_public_path__ + "static/media/contact-02.9703d130270eab64fa1c687c97448be2.svg";
export { ForwardRef as ReactComponent };